import React, { useState } from "react";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import { FormikValues } from "formik";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import useValidationSchemaMail, { VerificationMail } from "src/pages/finalisation/etapes/verificationMail/codeMailSend/useValidationSchemaMail";
import CodeMailSendFormContent from "src/pages/finalisation/etapes/verificationMail/codeMailSend/CodeMailSendFormContent";
import { AxiosError } from "axios";
import { UserToFinalize } from "src/domain/UserToFinalize";

export type CodeMailSendFormProps = {
  initialValues: VerificationMail;
  submitSuccessHandler: (result: GenericApiResponse<any>, values: FormikValues) => void;
  submitFormAPI: (values: FormikValues) => Promise<any>;
  allowRattachement?: boolean;
  userToFinalize?: UserToFinalize;
  displayCancelBtn?: boolean;
  cancelCallback?: () => void;
};

const CodeMailSendForm = ({ initialValues, submitSuccessHandler, submitFormAPI, allowRattachement, userToFinalize, displayCancelBtn, cancelCallback }: CodeMailSendFormProps) => {
  const validationSchema = useValidationSchemaMail();
  const [customError, setCustomError] = useState<AxiosError>();

  const handleCustomError = (err: AxiosError) => {
    setCustomError(err);
  }

  return (
    <AppFormik
      enableReinitialize
      initialValues={initialValues}
      submitFormAPI={submitFormAPI}
      submitSuccessHandler={submitSuccessHandler}
      validationSchema={validationSchema}
      customError={customError}
    >
      <CodeMailSendFormContent
        userToFinalize={userToFinalize}
        allowRattachement={allowRattachement}
        setCustomError={handleCustomError}
        displayCancelBtn={displayCancelBtn}
        cancelCallback={cancelCallback} />
    </AppFormik>
  );
};

export default CodeMailSendForm;